import React, { useMemo } from 'react';
import DiagnosisChart from '../Common/WellDiagnosisChart';
import { mapXYArrays } from '../../../utilities/DiagnosisHelper';

interface ValidatedIPRChartProps {
  chartData: any;
  parameters: any;
}

const ValidatedIPRChart: React.FC<ValidatedIPRChartProps> = ({ chartData, parameters }) => {
  const transformedData = useMemo(() => {
    if (!chartData) return chartData;
    return mapXYArrays(chartData, ['RatesVsPwf']);
  }, [chartData]);

  const isEmpty = transformedData == null || (Array.isArray(transformedData) && transformedData.length === 0);

  return (
    <DiagnosisChart
      chartData={transformedData}
      seriesConfig={parameters}
      widgetHeader='Validated IPR'
      xAxisLabel='Total rate (stb/d)'
      yAxisLabel='Pressure (psig)'
      chartLabel={isEmpty ? '' : 'Inflow performance relationship (IPR)'}
    />
  );
};

export default ValidatedIPRChart;
